// ============================================================================
// MEAL ENTITLEMENT SERVICE (buffet check-off slice 1)
// ============================================================================
// crs.Api.Controllers.MealModule.MealEntitlementController -> /api/v1/MealEntitlement
// A stay's meal allowances and its MAP meal preference (In-House Guests → Meals).
// pms-inhouse view reads; pms-inhouse meals changes — both checked by the server.

import { get, put } from '../client/axiosClient';
import { buildEndpointWithParams } from '../endpoints/base.endpoints';
import type { ApiResponse, ID } from '../types';
import type {
  SetMealDayChoiceRequest,
  SetStayMealPreferenceRequest,
  StayMeals,
} from '../types/stayMeals.types';

const BASE = '/MealEntitlement';

const unwrap = <T,>(res: { data?: ApiResponse<T> }, fallback: string): T => {
  if (res.data?.data === undefined || res.data?.data === null) throw new Error(res.data?.message || fallback);
  return res.data.data;
};

/** yyyy-MM-dd of a server date, for the route. */
const dayOf = (date: string) => date.slice(0, 10);

class MealEntitlementService {
  async getStay(bookingId: ID): Promise<StayMeals> {
    const res = await get<ApiResponse<StayMeals>>(buildEndpointWithParams(`${BASE}/stay/:id`, { id: bookingId }));
    return unwrap(res, 'The stay\'s meals could not be read.');
  }

  async setPreference(bookingId: ID, request: SetStayMealPreferenceRequest): Promise<StayMeals> {
    const res = await put<ApiResponse<StayMeals>>(
      buildEndpointWithParams(`${BASE}/stay/:id/preference`, { id: bookingId }), request);
    return unwrap(res, 'The MAP meal preference was not saved.');
  }

  async setDay(bookingId: ID, date: string, request: SetMealDayChoiceRequest): Promise<StayMeals> {
    const res = await put<ApiResponse<StayMeals>>(
      buildEndpointWithParams(`${BASE}/stay/:id/days/:date`, { id: bookingId, date: dayOf(date) }), request);
    return unwrap(res, 'The day\'s MAP meal was not saved.');
  }
}

export const mealEntitlementService = new MealEntitlementService();
